export default "__VITE_ASSET__LgJxcj8T__"